// var Color = require("color");
// import convert from "color-convert";

export function scale(value, inMin, inMax, outMin, outMax) {
  return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
}

export function logScale(
  enteredValue,
  minEntry,
  maxEntry,
  normalizedMin,
  normalizedMax
) {
  var mx =
    Math.log2(enteredValue - minEntry) / Math.log2(maxEntry - minEntry);
  var preshiftNormalized = mx * (normalizedMax - normalizedMin);
  var shiftedNormalized = preshiftNormalized + normalizedMin;

  return shiftedNormalized;
}

export function getRandomInRange(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
  spe;
}

export function getRandomRGBColor() {
  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  const r = getRandom(0, 255);
  const g = getRandom(0, 255);
  const b = getRandom(0, 255);

  return `rgb(${r}, ${g}, ${b})`;
}

export function getRandomInArray(arr) {
  return arr[getRandomInRange(0, arr.length - 1)];
}

export function* makeRangeIterator(start = 0, end = 100, step = 1) {
  while (true) {
    for (let i = start; i < end; i += step ) {
      yield i;
    }
    for (let i = end; i > start; i -= step) {
      yield i;
    }
  }
}

window.getRandomInArray = getRandomInArray;

// export function getResponsiveRGBColor(colorValues, colorSystem) {
//     responsiveColor = colorValues.map((val, idx) => {
//         if (val === -1) {
//             if (colorSystem === "cmyk") {
//                 return getRandomInRange(0, 100);
//             }
//             if (colorSystem === "lab") {
//                 return idx === 0
//                     ? getRandomInRange(0, 100)
//                     : getRandomInRange(-100, 100);
//             }
//             if (colorSystem === "rgb") {
//                 return getRandomInRange(0, 255);
//             }
//         } else {
//             return val;
//         }
//     });

//     if (colorSystem === "rgb") {
//         rgb = responsiveColor;
//     } else if (colorSystem === "cmyk") {
//         rgb = Color.cmyk(responsiveColor);
//     } else if (colorSystem === "lab") {
//         console.log(convert);
//         rgb = convert.lab.rgb(responsiveColor);
//     }

//     return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${1})`;
// }
